import PropTypes from 'prop-types';

const OptionsIcon = () => {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.625 9C11.625 10.4497 10.4497 11.625 9 11.625C7.55025 11.625 6.375 10.4497 6.375 9C6.375 7.55025 7.55025 6.375 9 6.375C10.4497 6.375 11.625 7.55025 11.625 9Z'
        stroke='#1B4332'
        strokeWidth='1.5'
      />
      <path
        d='M15.5929 6.86401C16.1976 7.90632 16.5 8.42748 16.5 9C16.5 9.57252 16.1976 10.0937 15.5929 11.136L14.1502 13.6228C13.5479 14.661 13.2467 15.1801 12.7515 15.4651C12.2562 15.75 11.6551 15.75 10.453 15.75L7.547 15.75C6.34487 15.75 5.7438 15.75 5.24855 15.4651C4.7533 15.1801 4.45214 14.661 3.84983 13.6228L2.40706 11.136C1.80235 10.0937 1.5 9.57252 1.5 9C1.5 8.42748 1.80235 7.90632 2.40706 6.864L3.84983 4.37716C4.45215 3.33897 4.7533 2.81988 5.24855 2.53494C5.7438 2.25 6.34487 2.25 7.547 2.25L10.453 2.25C11.6551 2.25 12.2562 2.25 12.7515 2.53494C13.2467 2.81988 13.5479 3.33897 14.1502 4.37716L15.5929 6.86401Z'
        stroke='#1B4332'
        strokeWidth='1.5'
      />
    </svg>
  );
};

OptionsIcon.propTypes = {
  className: PropTypes.string,
};

export default OptionsIcon;
